// firebase/index
export const firebaseConfig = {
	apiKey: "AIzaSyCBZ8Hbxy7PhYuhpytt9SYDyP9tTUJoGfY",
	authDomain: "seminariopiarc.firebaseapp.com",
	projectId: "seminariopiarc",
	storageBucket: "seminariopiarc.appspot.com",
	messagingSenderId: "228679225727",
	appId: "1:228679225727:web:242b28efd5956919fb0a4a",
	measurementId: "G-MRZY4WVLBN"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/seminariopiarc.appspot.com/o/'